var $388b617130f03bd4$exports = {};
// Scrollspy functionality (IntersectionObserver)
const $388b617130f03bd4$var$observer = new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
        const id = entry.target.getAttribute("id");
        const navLink = document.querySelector(`[href="#${id}"]`);
        if (!navLink) return; // Falls kein passender Link existiert, abbrechen
        if (entry.isIntersecting) // Use Tailwind classes to highlight the active link
        navLink.classList.add("dark:text-primary", "font-semibold", "border-b-2", "dark:border-primary", "border-brand-primary", "pb-1");
        else navLink.classList.remove("dark:text-primary", "font-semibold", "border-b-2", "dark:border-primary", "border-brand-primary", "pb-1");
    });
}, {
    threshold: 0.5
});
document.querySelectorAll("section").forEach((section)=>$388b617130f03bd4$var$observer.observe(section));
// Modal functionality
function $388b617130f03bd4$var$openModal(id) {
    document.getElementById(id).classList.remove("hidden");
    document.body.style.overflow = "hidden";
}
function $388b617130f03bd4$var$closeModal(id) {
    document.getElementById(id).classList.add("hidden");
    document.body.style.overflow = "auto";
}
document.querySelectorAll(".btn-read-more, #btnImprint").forEach((button)=>{
    button.addEventListener("click", (event)=>{
        $388b617130f03bd4$var$openModal(event.target.dataset.projectId);
    });
});
document.querySelectorAll(".modal-close-btn, #btnCloseImprint").forEach((button)=>{
    button.addEventListener("click", (event)=>{
        $388b617130f03bd4$var$closeModal(event.target.dataset.projectId);
    });
});
// Light/Dark mode
const $388b617130f03bd4$var$themeToggleBtn = document.getElementById("themeToggleBtn");
const $388b617130f03bd4$var$htmlElement = document.documentElement;
// Check for saved theme preference or default to dark
$388b617130f03bd4$var$themeToggleBtn.addEventListener("click", ()=>{
    if ($388b617130f03bd4$var$htmlElement.classList.contains("dark")) {
        $388b617130f03bd4$var$htmlElement.classList.remove("dark");
        localStorage.setItem("theme", "light");
    } else {
        $388b617130f03bd4$var$htmlElement.classList.add("dark");
        localStorage.setItem("theme", "dark");
    }
});
// Mobile Navigation
const $388b617130f03bd4$var$toggle = document.getElementById("drawer-toggle");
const $388b617130f03bd4$var$menuLinks = document.querySelectorAll("#mobile-nav-links a");
$388b617130f03bd4$var$menuLinks.forEach((link)=>{
    link.addEventListener("click", (e)=>{
        // Prevent immediate navigation to show closing animation
        const targetHref = link.getAttribute("href");
        if (targetHref && targetHref !== "#") {
            e.preventDefault();
            // Uncheck toggle to trigger closing animation
            $388b617130f03bd4$var$toggle.checked = false;
            // Navigate after animation completes (approx 400ms based on CSS transition)
            setTimeout(()=>{
                if (link.getAttribute("target") === "_blank") window.open(targetHref, "_blank");
                else window.location.href = targetHref;
            }, 100);
        }
    });
});
// Career Show More / Show Less Toggle
const $388b617130f03bd4$var$toggleCareerBtn = document.getElementById("toggleCareerBtn");
if ($388b617130f03bd4$var$toggleCareerBtn) $388b617130f03bd4$var$toggleCareerBtn.addEventListener("click", ()=>{
    const extraSteps = document.querySelectorAll(".extra-career-step");
    let isHidden = false;
    extraSteps.forEach((step)=>{
        if (step.classList.contains("hidden")) {
            step.classList.remove("hidden");
            isHidden = true;
        } else step.classList.add("hidden");
    });
    if (isHidden) $388b617130f03bd4$var$toggleCareerBtn.innerText = "Show Less";
    else {
        $388b617130f03bd4$var$toggleCareerBtn.innerText = "Show More";
        const careerSection = document.getElementById("career");
        if (careerSection) careerSection.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }
});


//# sourceMappingURL=app.d2c8fc3c.js.map
